export const PMPiSearchPolling = (function() {
  var wait_delta = 1, timer = null, should_time = true, record_url = null;

  var instantiate = function (url) {
    // Reset state for new polling session
    should_time = true;
    wait_delta = 1;
    clearTimeout(timer);

    record_url = url;
    _poll();
  };

  var _timeout_error = function (rx_request) {
    should_time = false;
    if (!rx_request.patient_results_empty) {
      _completed(rx_request);
    } else {
      clearTimeout(timer);
      $(document).trigger('PMPi:timeout');
    }
  };

  var _completed = function (rx_request) {
    should_time = false;
    clearTimeout(timer);
    $(document).trigger('PMPi:complete', rx_request);
  };

  var _poll = function () {
    console.log('Polling external search status...', record_url);
    $.ajax(record_url)
      .done(function (data) {
        console.log('Poll response:', data);
        if (data.status === 'complete') {
          _completed(data.rx_request);
          return;
        }

        if (wait_delta >= 1.09) {
          wait_delta = Math.floor(wait_delta) * 2;
        } else {
          wait_delta = wait_delta + 0.01;
        }

        //almost 2 minutes of actual wait time
        if (wait_delta > 110) {
          _timeout_error(data.rx_request);
          return;
        } else if (should_time) {
          console.log('Scheduling next poll in', wait_delta, 'seconds');
          timer = setTimeout(function(){
            _poll();
          }, wait_delta * 1000);
        } else {
          console.log('Polling stopped: should_time is false');
        }
      })
      .fail(function(xhr, status, error) {
        console.error('Polling failed:', status, error);
        // Stop polling on error
        should_time = false;
        clearTimeout(timer);
      });
  };

  return {
    instantiate: instantiate
  };
})();

window.PMPiSearchPolling = PMPiSearchPolling;